import BaseLayout from "../components/layouts/BaseLayout";

export default () => (
  <BaseLayout>
    <section className="section">
      <br/>
      <h1 className="title is-size-1 is-size-3-mobile is-size-2-tablet has-text-centered">Boas práticas em videoconferências</h1>
      <br/>
      <br/>
      <br/>

      <div className="columns">

        <div className="column">

          <article className="media">
            <figure className="media-left">
              <p className="image has-text-centered">
                <i className="far fa-clock fa-5x" aria-hidden="true"></i>
              </p>
            </figure>

            <div className="media-content">
              <div className="content">
                <h3 className="title is-size-3 is-size-5-mobile is-size-4-tablet">
                  Estar na sala com o terminal ligado com antecedência mínima de 15 minutos, para testes de áudio e vídeo.
                </h3>
              </div>
            </div>
          </article>

        </div>{/* .column */}

        <div className="column">

          <article className="media">
            <figure className="media-left">
              <p className="image has-text-centered">
                <i className="far fa-comment-alt fa-5x" aria-hidden="true"></i>
              </p>
            </figure>

            <div className="media-content">
              <div className="content">
                <h3 className="title is-size-3 is-size-5-mobile is-size-4-tablet">
                  Falar pausadamente e aguardar, pois pode ocorrer atraso de alguns segundos nas transmissões de áudio e vídeo.
                </h3>
              </div>
            </div>
          </article>

        </div>{/* .column */}

      </div>{/* .columns */}

      <div className="columns">

        <div className="column">

          <article className="media">
            <figure className="media-left">
              <div className="image has-text-centered">
                <span className="fa-layers fa-fw fa-5x">
                  <i className="fas fa-users" data-fa-transform="shrink-7 up-1"></i>
                  <i className="fas fa-desktop"></i>
                </span>
              </div>
            </figure>

            <div className="media-content">
              <div className="content">
                <h3 className="title is-size-3 is-size-5-mobile is-size-4-tablet">
                  Enquadrar-se na imagem da câmera para que todos possam ver os participantes da reunião.
                </h3>
              </div>
            </div>
          </article>

        </div>{/* .column */}

        <div className="column">

          <article className="media">
            <figure className="media-left">
              <div className="image has-text-centered">
                <span className="fa-layers fa-fw fa-5x">
                  <i className="far fa-comments" data-fa-transform="shrink-9"></i>
                  <i className="fas fa-ban"></i>
                </span>
              </div>
            </figure>

            <div className="media-content">
              <div className="content">
                <h3 className="title is-size-3 is-size-5-mobile is-size-4-tablet">
                  Evitar conversas paralelas ou ruídos quando o microfone estiver ligado, pois ele possui alta sensibilidade de captação.
                </h3>
              </div>
            </div>
          </article>

        </div>{/* .column */}

      </div>{/* .columns */}

      <div className="columns">

        <div className="column">

          <article className="media">
            <figure className="media-left">
              <p className="image has-text-centered">
                <i className="fas fa-video fa-5x" aria-hidden="true"></i>
              </p>
            </figure>

            <div className="media-content">
              <div className="content">
                <h3 className="title is-size-3 is-size-5-mobile is-size-4-tablet">
                  Olhar para a câmera ap falar. Assim conversará com os outros participantes de forma mais natural.
                </h3>
              </div>
            </div>
          </article>

        </div>{/* .column */}

        <div className="column">

          <article className="media">
            <figure className="media-left">
              <p className="image has-text-centered">
                <i className="fas fa-microphone-slash fa-5x" aria-hidden="true"></i>
              </p>
            </figure>

            <div className="media-content">
              <div className="content">
                <h3 className="title is-size-3 is-size-5-mobile is-size-4-tablet">
                  Desligar o microfone quando não estiver falando.
                </h3>
              </div>
            </div>
          </article>

        </div>{/* .column */}

      </div>{/* .columns */}

      <div className="columns">

        <div className="column">

          <article className="media">
            <figure className="media-left">
              <div className="image has-text-centered">
                <span className="fa-layers fa-fw fa-5x">
                  <i className="fas fa-microphone" data-fa-transform="shrink-7 down-4 left-6"></i>
                  <i className="fas fa-arrows-alt-h" data-fa-transform="shrink-12 left-.5 rotate--30"></i>
                  <i className="fas fa-user" data-fa-transform="shrink-9 up-4 right-6"></i>
                </span>
              </div>
            </figure>

            <div className="media-content">
              <div className="content">
                <h3 className="title is-size-3 is-size-5-mobile is-size-4-tablet">
                  Evitar falar muito próximo ao microfone. A distância ideal entre o microfone e o locutor deve ser de 40cm a 2 metros.
                </h3>
              </div>
            </div>
          </article>

        </div>{/* .column */}

        <div className="column">

          <article className="media">
            <figure className="media-left">
              <div className="image has-text-centered">
                <span className="fa-layers fa-fw fa-5x">
                  <i className="fas fa-laptop" data-fa-transform="shrink-10"></i>
                  <i className="fas fa-ban"></i>
                </span>
              </div>
            </figure>

            <div className="media-content">
              <div className="content">
                <h3 className="title is-size-3 is-size-5-mobile is-size-4-tablet">
                  Evitar bater na superfície na qual está o microfone, usar notebooks ou deixar celulares vibrando sobre ela, impedindo, assim, ruídos no áudio.
                </h3>
              </div>
            </div>
          </article>

        </div>{/* .column */}

      </div>{/* .columns */}
    </section>

    <style jsx>{`
      .column {
        margin-bottom: 50px;
      }

      .image {
        height: 128px;
        width: 128px;
        margin-right: 10px;
        color: #00693e;
      }

      @media only screen and (max-width: 1023px) and (min-width: 768px) {
        .image {
          font-size: 12px;
          height: 76px;
          width: 76px;
        }
      }

      @media only screen and (max-width: 769px) {
        .image {
          font-size: 12px;
          height: 64px;
          width: 64px;
          margin-left: 5px;
        }
      }
    `}</style>
  </BaseLayout>
)


// WEBPACK FOOTER //
// pages/recomendacoes.js